import { motion, useAnimate, type AnimationSequence } from 'framer-motion'
import { useEffect } from 'react'
import { useGlobalStore } from '../../../../store/global-store'
import type { MessageUserLevelUp } from '../../../../types/lives/messages'

interface Props {
  toast: MessageUserLevelUp
}

export function Toast({ toast }: Props) {
  const frame =
    'https://storage.didderlive.com/items/frame-ranking-top-1.png'

  const remove = useGlobalStore((state) => state.removeNotifyUserLevelUp)

  const [scope, animate] = useAnimate()

  useEffect(() => {
    const sequence: AnimationSequence = [
      [scope.current, { opacity: 1 }, { duration: 1 }],
      [scope.current, { opacity: 1 }, { duration: 2, delay: 1 }],
    ]

    if (toast) {
      animate(sequence)
    }
  }, [toast, scope, animate, remove])

  return (
    <motion.div className="flex flex-col items-center gap-10 opacity-0 mt-">
      <span className="text-3xl text-white">{toast?.username}</span>

      <div
        className="rounded-full bg-black"
        style={{
          backgroundImage: `url(${toast?.imgUser})`,
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'center',
          backgroundSize: 'contain',
        }}
      >
        <img src={frame} className="w-40 h-40 scale-[1.5]" />
      </div>

      <span
        className="colored-text text-3xl bg-clip-text text-transparent font-bold"
        style={{
          backgroundImage: 'linear-gradient(orangered, red)',
          // "-webkit-background-clip": "text",
        }}
      >
        {toast?.newLevel}
      </span>
    </motion.div>
  )
}
